import { ConfigSlideId, SelectFieldOption } from '@/eventConfig/types.ts';
import { ascend, path, propOr, sortWith } from 'ramda';
import { FieldType } from '@/form/FormProvider.tsx';

export const i18nSortSelectOptions = (selectOptions: SelectFieldOption[], lang: string) => {
  // Sorts the `selectOptions` first by _order, then by label.[lang]
  // This way we can ensure, that countries in the country list are ordererd
  // alphabetically even when translated
  return sortWith([
    //  If a key tried to access by prop('x') is not present, it returns undefined and breaks the sortWith(...)
    ascend(propOr(Number.MAX_SAFE_INTEGER, '_order')),
    // @ts-ignore
    ascend(path(['label', lang])),
  ])(selectOptions) as SelectFieldOption[];
};

export const andBoolArray = (data: boolean[]): boolean => {
  // This &&'s all elements in an array to reduce it to a single boolean
  return data.reduce((curr: boolean, acc: boolean) => {
    return curr && acc;
  }, true);
};

export const orBooleanArray = (data: boolean[]): boolean => {
  //this ||'s all elements in an array to reduce it to a single boolean
  return data.reduce((curr: boolean, acc: boolean) => {
    return curr || acc;
  }, false);
};

export const isBmiSlide = (slideId: ConfigSlideId) => {
  const bmiSlides = ['bmi', 'fieldTest1'];

  return bmiSlides.includes(slideId);
};

// Infers gender from salutation field value
export const getGenderFromSalutation = (salutation?: FieldType): 'M' | 'F' | undefined => {
  if (!salutation) return undefined;

  const normalized = salutation.toString().trim().toLowerCase();

  if (['mr.', 'mr'].includes(normalized)) return 'M';
  if (['mrs.', 'ms.', 'miss', 'mrs', 'ms'].includes(normalized)) return 'F';

  return undefined;
};
